export const isDefined = (x: unknown): boolean =>
  x !== null && typeof x !== 'undefined';
export const isObject = (x: unknown): boolean =>
  isDefined(x) && typeof x === 'object';
export const isFunction = (x: unknown): boolean => typeof x === 'function';
// For type refinements: https://flow.org/en/docs/types/mixed/
export const stringify = (x: unknown): string =>
  typeof x === 'string' ? x : '';
